import Api from "./Api";
import Csrf from "./Csrf";

export default {
  async index() {
    await Csrf.getCookie();

    return Api.get("/system-messages");
  },
  async indexSelector() {
    await Csrf.getCookie();

    return Api.get("/system-messages/selector");
  },

  async update(id, form) {
    await Csrf.getCookie();

    return Api.patch("/system-messages/" + id, form);
  },

  async add(form) {
    await Csrf.getCookie();

    return Api.post("/system-messages", form);
  },

  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/system-messages/" + id);      
      
  },
 
};
